import { render, staticRenderFns } from "./CodeSignup.vue?vue&type=template&id=3487f4af&scoped=true&"
import script from "./CodeSignup.vue?vue&type=script&lang=ts&"
export * from "./CodeSignup.vue?vue&type=script&lang=ts&"
import style0 from "./CodeSignup.vue?vue&type=style&index=0&id=3487f4af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487f4af",
  null
  
)

export default component.exports